import type { AiProviderPayload } from '@Application/Ai/AiConfiguration/Providers/Actions/aiProvidersFetched';

export type AiProviderCreatedPayload = AiProviderPayload;

export type AiProviderCreatedAction = {
	type: 'AI_PROVIDER_CREATED';
	payload: AiProviderCreatedPayload;
	accountId: number;
};

export default (payload: AiProviderCreatedPayload, accountId: number): AiProviderCreatedAction => ({
	type: 'AI_PROVIDER_CREATED',
	payload,
	accountId,
});
